<script setup>
/**
 * Loading overlay that covers its parent container while data loads.
 *
 * This is a zero-prop wrapper — all props are forwarded via `$attrs` directly to Quasar's
 * `q-inner-loading`. See the [Quasar q-inner-loading API](https://quasar.dev/vue-components/inner-loading)
 * for the full prop list.
 *
 * @status recommended
 * @group status-feedback
 * @useWhen Overlaying a loading indicator on top of a content area while an async operation runs
 */
defineOptions({ name: 'HrInnerLoading' });
</script>

<template>
  <q-inner-loading v-bind="$attrs">
    <!-- @slot Custom loading indicator; renders a spinner by default when empty. -->
    <slot />
  </q-inner-loading>
</template>
